import axios from 'axios'

export default {
  namespaced: true,
  state: {
    employeeGroupGrid: [],
    employeeGroupAll: [],
    employeeGroupShow: {},
    employeeGroupWorkPeriods: [],
    pageData: null,
  },
  mutations: {
    setEmployeeGroupGrid(state, payload) {
      state.employeeGroupGrid = payload
    },
    setEmployeeGroupAll(state, payload) {
      state.employeeGroupAll = payload
    },
    setEmployeeGroupShow(state, payload) {
      state.employeeGroupShow = payload ? payload : {}
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
    setEmployeeGroupWorkPeriods(state, payload) {
      state.employeeGroupWorkPeriods = payload ? payload : []
    },
  },
  getters: {
    employeeGroupGrid: (state) => {
      return state.employeeGroupGrid
    },
    employeeGroupAll: (state) => {
      return state.employeeGroupAll
    },
    employeeGroupShow: (state) => {
      return state.employeeGroupShow
    },
    pageData: (state) => {
      return state.pageData
    },
    employeeGroupWorkPeriods: (state) => {
      return state.employeeGroupWorkPeriods
    },
  },
  actions: {
    onEmployeeGroupGrid({ commit, rootState }, { limit, page, filters, sort, search }) {
      commit('setLoadingAnimation', true, { root: true })
      let url = rootState.apiDomain + '/api/admin/work/group/grid?limit=' + limit + '&page=' + page
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=name:asc'
      }
      if (filters) url = url + filters
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          limit: limit,
          page: page,
          method: 'GET',
        })
          .then((resp) => {
            commit('setEmployeeGroupGrid', resp.data.data)
            commit('setPageData', resp.data)
            commit('setLoadingAnimation', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onEmployeeGroupWorkPeriods({ commit, rootState }, { group_id, is_extra }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/group/periods?group_id=' +
            group_id +
            '&is_extra=' +
            is_extra +
            '&order[]=id:desc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setEmployeeGroupWorkPeriods', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onEmployeeGroupAll({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/group/grid?limit=0' + '&order[]=name:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setEmployeeGroupAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onEmployeeGroupShow({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/group/' + id,
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setEmployeeGroupShow', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onEmployeeGroupCreate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/group',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onEmployeeGroupUpdate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/group',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onEmployeeGroupDelete({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/group/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
